module.exports = __webpack_public_path__ + "static/media/scene4_furba4.35ec05e5.wav";